<template>
  <navbar :show-navbar="showNavbar" :transparent="false" id="nav" class="base-bg-clear">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{ toggled: showNavbar }">
        <navbar-toggle-button @click="toggleNavbar" target="#nav">
        </navbar-toggle-button>
      </div>

<!--      <a class="navbar-brand" href="javascript:;">{{ $route.name }}</a>-->
        <router-link to="/dashboard">
            <img src="./../../assets/images/logo/logo.png" class="img" alt="" style="height: 45px !important; width: auto !important; margin-right: 15px"/>
        </router-link>
    </div>

    <template v-slot:navbar-menu>

      <ul class="navbar-nav">

          <li class="nav-item">
              <router-link to="/task/new" class="nav-link">
                  <i class="now-ui-icons media-1_button-play"></i>
                  <p><span>New Analysis</span></p>
              </router-link>

          </li>
          <li class="nav-item">
            <router-link to="/task/list" class="nav-link">
              <i class="now-ui-icons design_bullet-list-67"></i>
              <p><span>My Analyses</span></p>
            </router-link>
          </li>


<!--          <drop-down tag="li" position="right" class="nav-item" icon="now-ui-icons files_box" :title="$t('document.bookkeeping')">-->
<!--            <router-link to="/documents/received" class="dropdown-item">-->
<!--              <i class="now-ui-icons arrows-1_cloud-download-93"></i> {{ $t('document.received') }}-->
<!--            </router-link>-->

<!--            <router-link to="/documents/uploaded" class="dropdown-item">-->
<!--              <i class="now-ui-icons arrows-1_cloud-upload-94"></i> {{ $t('document.sent') }}-->
<!--            </router-link>-->


<!--            <br>-->
<!--            <div class="dropdown-divider"></div>-->
<!--            <li class="text-center"> {{ $t('document.upload_new') }}</li>-->

<!--            <router-link to="/documents/new_company_house_docs" class="dropdown-item">-->
<!--              <i class="now-ui-icons business_bank"></i> {{ $t('documents_folders.companyHouse') }}-->
<!--            </router-link>-->

<!--          </drop-down>-->


<!--          <drop-down v-if="isManager" tag="li" position="right" class="nav-item" icon="now-ui-icons business_briefcase-24" title="Manager">-->
<!--              <router-link to="/manager/users_stats" class="dropdown-item">-->
<!--                  <i class="now-ui-icons business_chart-pie-36"></i> Customers-->
<!--              </router-link>-->

<!--          </drop-down>-->

<!--        <drop-down tag="li" position="right" class="nav-item" :title="$i18n.locale.toUpperCase()" :img="'/img/flags/' + $i18n.locale.toUpperCase() + '.png'">-->
<!--          <a class="dropdown-item" v-for="lang in langs" v-bind:key="lang" @click="changeLocale(lang)"-->
<!--             :set="langImg = '/img/flags/' + lang.toUpperCase() + '.png'">-->
<!--            <img v-bind:src="langImg" style="padding-right: 4px; height: 24px !important; width:auto !important;"> {{ lang.toUpperCase() }}-->
<!--          </a>-->
<!--        </drop-down>-->



        <li class="nav-item">
          <a class="nav-link" @click="logout">
            <i class="now-ui-icons media-1_button-power"></i>
            <p><span class="d-lg-none d-md-block">{{ $t('login.logout') }}</span></p>
          </a>


        </li>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import axios from "axios";
import {Role} from "src/role";
import Swal from "sweetalert2";
import {ElMessage} from "element-plus";

export default {
  components: {
    Navbar,
    NavbarToggleButton,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      langs: ['en', 'it'],
      isManager: this.$store.getters.getUserRoles.includes(Role.Manager)
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    // toggleSidebar() {
    //   this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    // },
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showNavbar = !this.showNavbar;
    },
    // hideSidebar() {
    //   this.$sidebar.displaySidebar(false);
    // },
    async recaptcha() {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('registration');
    },
    async changeLocale(lang) {
      this.$i18n.locale = lang;
      this.$store.commit('setLang', lang);
      if(this.$store.getters.isLoggedIn) {
          let token = await this.recaptcha();
          axios.patch(process.env.VUE_APP_SERVER_BASE_URL + "ai_users/" + this.$store.getters.getUserId,
              {language: lang, captchaToken: token},
              {headers: {'Content-Type': 'application/merge-patch+json'}}
          ).then((response) => {}).catch((error) => {});
      }
    },
    logout() {
      axios.post(process.env.VUE_APP_SERVER_BASE_URL + 'logout', '')
      .then(response => {
        this.$store.commit('logout');
        this.$router.push('/');
      }).catch(error => {
        if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
          this.$store.commit('logout');
          this.$router.push('/login');
        }
        else
          console.log("error in logout: " + error);
      });
    },
  },
};
</script>
<style></style>
